import type { IconSvgObject } from './types';

const CursorAddSelection02Icon: IconSvgObject = [
  ["path", { d: "M3.60004 3.03043L18.7175 8.84482C19.1034 8.99327 19.0909 9.54358 18.6986 9.67435L12.1395 11.8607C12.0079 11.9046 11.9046 12.0079 11.8607 12.1395L9.67435 18.6986C9.54358 19.0909 8.99327 19.1034 8.84482 18.7175L3.03043 3.60004C2.89333 3.24357 3.24357 2.89333 3.60004 3.03043Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.5 14V21M21 17.5L14 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CursorAddSelection02Icon;
